import { render, staticRenderFns } from "./EduCreateExampaper.vue?vue&type=template&id=4b7180e5"
import script from "./EduCreateExampaper.vue?vue&type=script&lang=js"
export * from "./EduCreateExampaper.vue?vue&type=script&lang=js"
import style0 from "./EduCreateExampaper.vue?vue&type=style&index=0&id=4b7180e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports